// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"603":"0d28af09","961":"e89770a1"}[chunkId] + ".css";
};